export default __webpack_public_path__ + "static/media/bd_ph.16c7b02c.jpg";